import type { Prototype } from "../prototype-types";

export const victoriaSchusterPrototypes: Prototype[] = [
  {
    id: "vs-retailer-command-center",
    name: "Retailer Command Center",
    path: "/vs/retailer-command-center",
    description:
      "A command center for busy store owners to monitor and act on messages, orders, invoices, shipping, reorders, and brand updates.",
    owner: "Victoria Schuster",
    createdAt: "2026-06-15",
    lastUpdated: "2026-06-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/1c429457ae61077b7f5bc5ea0c2f8c55661bd236302b3b1489550cd3db44776a.png",
    creationTool: "cursor",
  },
  {
    id: "vs-holiday-hubs",
    name: "Holiday Hubs",
    path: "/vs/holiday-hubs",
    description:
      "Generic seasonal hub template with two layout variants: simplified (no brands&#x2F;shortcuts) and minimal (title-only header). Toolbar switches hub theme and viewport.",
    owner: "Victoria Schuster",
    createdAt: "2026-07-14",
    lastUpdated: "2026-07-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/f7bd7497af24f35822606ec18614c06c214983086b253141e66597d76d9fb7b3.png",
    creationTool: "claude-code",
  },
  {
    id: "vs-social-proof-heart-and-carts",
    name: "Social Proof Heart and Carts",
    path: "/vs/social-proof-heart-and-carts",
    description:
      "Explores social proof treatments with heart and cart indicators on product tiles.",
    owner: "Victoria Schuster",
    createdAt: "2026-07-28",
    lastUpdated: "2026-07-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/4a3928e27d89c0f78af217dd05ab578799c55d211615029b137501ab58f94c98.png",
    creationTool: "claude-code",
  },
  {
    id: "vs-rationale-hubs-product-tile",
    name: "Rationale Hubs Product Tile",
    path: "/vs/rationale-hubs-product-tile",
    description: "Explores product tile treatments for rationale hubs.",
    owner: "Victoria Schuster",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/054bb7a86ec2497d028244faaa6d4827a9ddae6df9b3b300d5455ca988cb644f.png",
    creationTool: "claude-code",
  },
  {
    id: "vs-inspire-big-bets-browse",
    name: "Inspire Big Bets Browse",
    path: "/vs/inspire-big-bets-browse",
    description:
      "Explores geo-based product discovery with a map hero, location shortcuts, and locally popular product carousels.",
    owner: "Victoria Schuster",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    project: "Inspire Big Bets '26",
    figmaLink:
      "https://www.figma.com/design/jPUSKT6dOYM572rWY1XWQu/Inspire-Big-Bets--26?node-id=546-37075",
    thumbnail: "/images/thumbnails/vs-inspire-big-bets-browse.png",
    creationTool: "cursor",
  },
];
